import React, { Component } from 'react';
import { MLOpsMetricResult } from '../../../../domain/mlops/MLOpsDomains';
import CustomTable, { CustomColumnProps } from '../../../custom/CustomTable';
import CustomTableContentWrapper from '../../../custom/CustomTableContentWrapper';
import FormicaLabel from '../../../custom/FormicaLabel';

class MlOpsMetricResultsTable extends Component<Props> {
  render() {
    const { results } = this.props;
    return (
      <div>
        <FormicaLabel label={'Metric Results'} />
        <CustomTable columns={this.getColumns()} value={results} />
      </div>
    );
  }

  private getColumns(): CustomColumnProps[] {
    return [
      {
        field: 'name',
        header: 'Name',
        className: 'min-w-[8%]',
        body: (rowData: MLOpsMetricResult) => {
          return <CustomTableContentWrapper text={rowData.name}></CustomTableContentWrapper>;
        },
      },
      {
        field: 'version',
        header: 'Version',
        className: 'min-w-[7%]',
        body: (rowData: MLOpsMetricResult) => {
          return <CustomTableContentWrapper text={rowData.version}></CustomTableContentWrapper>;
        },
      },
      {
        field: 'threshold',
        header: 'Threshold',
        className: 'min-w-[7%]',
        body: (rowData: MLOpsMetricResult) => {
          const text = rowData.threshold?.toString();
          return <CustomTableContentWrapper text={text}></CustomTableContentWrapper>;
        },
      },
      {
        field: 'tpc',
        header: 'Tpc',
        className: 'min-w-[7%]',
        body: (rowData: MLOpsMetricResult) => {
          const text = rowData.tpc?.toString();
          return <CustomTableContentWrapper text={text}></CustomTableContentWrapper>;
        },
      },
      {
        field: 'fpc',
        header: 'Fpc',
        className: 'min-w-[7%]',
        body: (rowData: MLOpsMetricResult) => {
          const text = rowData.fpc?.toString();
          return <CustomTableContentWrapper text={text}></CustomTableContentWrapper>;
        },
      },
      {
        field: 'fnc',
        header: 'Fnc',
        className: 'min-w-[7%]',
        body: (rowData: MLOpsMetricResult) => {
          const text = rowData.fnc?.toString();
          return <CustomTableContentWrapper text={text}></CustomTableContentWrapper>;
        },
      },
      {
        field: 'tnc',
        header: 'Tnc',
        className: 'min-w-[7%]',
        body: (rowData: MLOpsMetricResult) => {
          const text = rowData.tnc?.toString();
          return <CustomTableContentWrapper text={text}></CustomTableContentWrapper>;
        },
      },
      {
        field: 'fpr',
        header: 'Fpr',
        className: 'min-w-[15%]',
        body: (rowData: MLOpsMetricResult) => {
          const text = rowData.fpr?.toString();
          return <CustomTableContentWrapper text={text}></CustomTableContentWrapper>;
        },
      },
      {
        field: 'fnr',
        header: 'Fnr',
        className: 'min-w-[7%]',
        body: (rowData: MLOpsMetricResult) => {
          const text = rowData.fnr?.toString();
          return <CustomTableContentWrapper text={text}></CustomTableContentWrapper>;
        },
      },
      {
        field: 'tnr',
        header: 'Tnr',
        className: 'min-w-[15%]',
        body: (rowData: MLOpsMetricResult) => {
          const text = rowData.tnr?.toString();
          return <CustomTableContentWrapper text={text}></CustomTableContentWrapper>;
        },
      },
      {
        field: 'accuracy',
        header: 'Accuracy',
        className: 'min-w-[15%]',
        body: (rowData: MLOpsMetricResult) => {
          const text = rowData.accuracy?.toString();
          return <CustomTableContentWrapper text={text}></CustomTableContentWrapper>;
        },
      },
      {
        field: 'precision',
        header: 'precision',
        className: 'min-w-[15%]',
        body: (rowData: MLOpsMetricResult) => {
          const text = rowData.precision?.toString();
          return <CustomTableContentWrapper text={text}></CustomTableContentWrapper>;
        },
      },
      {
        field: 'f1score',
        header: 'F1 Score',
        className: 'min-w-[15%]',
        body: (rowData: MLOpsMetricResult) => {
          const text = rowData.f1score?.toString();
          return <CustomTableContentWrapper text={text}></CustomTableContentWrapper>;
        },
      },
      {
        field: 'npv',
        header: 'Npv',
        className: 'min-w-[10%]',
        body: (rowData: MLOpsMetricResult) => {
          const text = rowData.npv?.toString();
          return <CustomTableContentWrapper text={text}></CustomTableContentWrapper>;
        },
      },
    ];
  }
}

interface Props {
  results: MLOpsMetricResult[];
}

export default MlOpsMetricResultsTable;
